export default "__VITE_ASSET__3dcaea84__"